import type { FC, ReactNode } from 'react'
import type { AppSettings } from '@/types'

import { cn } from '@/lib/utils'
import { useAcademic } from '@/components/providers/academic-provider'

type BrandMarkProps = {
    size?: number
    className?: string
    settings?: Pick<AppSettings, 'appName' | 'logoUrl' | 'logoSize'>
}

export const BrandMark: FC<BrandMarkProps> = ({ size, className, settings }): ReactNode => {
    const { data } = useAcademic()
    const source = settings ?? data.settings
    const dimension = size ?? source.logoSize
    const letter = source.appName.trim().charAt(0).toUpperCase() || 'A'

    return (
        <span
            className={cn(
                'grid shrink-0 place-items-center overflow-hidden rounded-[30%] font-extrabold text-white shadow-sm',
                'bg-[linear-gradient(135deg,var(--hero-1),var(--hero-2)_55%,var(--hero-3))] ring-1 ring-black/5 dark:ring-white/10',
                className
            )}
            style={{ width: dimension, height: dimension, fontSize: Math.round(dimension * 0.44) }}
            aria-hidden='true'
        >
            {source.logoUrl ? (
                // eslint-disable-next-line @next/next/no-img-element
                <img src={source.logoUrl} alt='' className='size-full object-cover' />
            ) : letter}
        </span>
    )
}
